import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { FileComponent } from './components/file/file.component';
import { FileGroupComponent } from './components/file-group/file-group.component';
import { StatusContainerComponent } from './components/status-container/status-container.component';
import { StatusIconComponent } from './components/status-icon/status-icon.component';
import { StatusRowComponent } from './components/status-row/status-row.component';
import { StatusTextGroupComponent } from './components/status-text-group/status-text-group.component';
import { ChameleonPipe } from './pipes/chameleon.pipe';
import { DateRangeValidatorDirective } from './directives/date-range-validator/date-range-validator.directive'
import { NgbdSortableHeader } from './directives/sort/sort.directive';
import { WorkflowConfirmationModalComponent } from './components/workflow-confirmation-modal/workflow-confirmation-modal.component';


@NgModule({
  declarations: [
    NgbdSortableHeader,
    DateRangeValidatorDirective,
    ChameleonPipe,
    ConfirmationModalComponent,
    FileComponent,
    FileGroupComponent,
    StatusContainerComponent,
    StatusRowComponent,
    StatusIconComponent,
    StatusTextGroupComponent,
    WorkflowConfirmationModalComponent
  ],
  imports: [
    CommonModule,
    NgbModule
  ],
  exports: [
    NgbdSortableHeader,
    DateRangeValidatorDirective,
    ChameleonPipe,
    ConfirmationModalComponent,
    FileComponent,
    FileGroupComponent,
    StatusContainerComponent,
    StatusRowComponent,
    StatusIconComponent,
    StatusTextGroupComponent,
    WorkflowConfirmationModalComponent
  ],
  entryComponents: [
    WorkflowConfirmationModalComponent
  ]
})
export class SharedModule { }
